var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-1"},[_c('div',{staticClass:"column is-12"},[_c('farmer-list')],1),_c('farmer-form'),_c('modal-history'),_c('modal-spinResult'),_c('modal-pickDayCSV',{attrs:{"type":"farmer"}}),_c('modal-upLoadPin')],1)}
var staticRenderFns = []

export { render, staticRenderFns }